module.exports = __webpack_public_path__ + "img/colombia.ecd28ebe.png";